import * as builder from './ducks/builder';
import * as i18n from './ducks/i18n';

/**
 * Reexports
 */
export { default as I18nProvider } from './i18n/I18nProvider';
export * from './layout/LayoutConfig';
export { default as LayoutConfig } from './layout/LayoutConfig';
export * from './layout/LayoutContext';
export { default as LayoutInitializer } from './layout/LayoutInitializer';
export { default as ThemeProvider } from './materialUIThemeProvider/ThemeProvider';
export * from './utils/utils';

/**
 * Ducks
 */

export const metronic = { i18n, builder };
